import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  type CabinUpgradePricingGetParams,
  type CabinUpgradeUpsertPayload,
  fetchCabinUpgradePricing,
  upsertCabinUpgrades,
} from '~/services/CharterService';

import { cabinUpgradePricingQueryKeys } from './charterUpgradePricingQueryKeys';

export function useGetCabinUpgradePricing(params: CabinUpgradePricingGetParams) {
  return useQuery({
    queryKey: cabinUpgradePricingQueryKeys.list(params),
    queryFn: () => fetchCabinUpgradePricing(params),
  });
}

export function useUpsertCabinUpgrades() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CabinUpgradeUpsertPayload) => upsertCabinUpgrades(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: cabinUpgradePricingQueryKeys.all });
    },
  });
}
